import React, { Fragment } from 'react';
import SettingsHeader from 'src/components/SettingsHeader';
import { useAppState, useOnMount } from 'src/lib/hooks';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Formik,
  FormInput,
  FormSubmit,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  toast,
  useApp
} from 'straightline-ui';
import { COUNTRIES, STATE_OPTIONS } from 'straightline-utils/constants';

export default function Shipper() {
  const {
    state: { shipper },
    setInState
  } = useAppState();
  const app = useApp();
  const service = app.service('api/shipper');

  useOnMount(() => {
    service.find().then((shipper) => {
      setInState('shipper', shipper);
    });
  });

  const handleSubmit = (data, formik) => {
    service
      .create(data)
      .then((updatedShipper) => {
        setInState('shipper', updatedShipper);
        formik.resetForm({ values: updatedShipper });
        toast.success(`Business updated!`);
      })
      .catch((err) => {
        toast.errors(err);
        if (err.errors) {
          formik.setErrors(err.errors);
        }
        formik.setSubmitting(false);
      });
  };

  return (
    <Container fluid>
      <SettingsHeader activeTab="shipper" />
      <Row>
        <Col xl="5">
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  ...shipper,
                  address: {
                    address_1: undefined,
                    address_2: undefined,
                    city: undefined,
                    state: undefined,
                    postal_code: undefined,
                    country: undefined,
                    ...shipper.address
                  }
                }}
                enableReinitialize={true}
                onSubmit={handleSubmit}
                validationSchema={service.schema}
                render={({ isSubmitting, setValues, values }) => {
                  return (
                    <Form>
                      <FormGroup>
                        <Label>Business Name*</Label>
                        <FormInput name="name" disabled={isSubmitting} />
                        <FormFeedback name="name" />
                      </FormGroup>
                      <FormGroup>
                        <div className="d-flex justify-content-between align-items-center">
                          <Label>Billing Emails*</Label>
                          <Button
                            size="sm"
                            color="link"
                            type="button"
                            onClick={() => {
                              setValues({
                                ...values,
                                billing_emails: [...values.billing_emails, '']
                              });
                            }}
                          >
                            Add Email
                          </Button>
                        </div>
                        {values.billing_emails.map((email, index) => {
                          if (index === 0) {
                            return (
                              <Fragment key={index}>
                                <FormInput
                                  name="billing_emails.0"
                                  disabled={isSubmitting}
                                />
                                <FormFeedback name="billing_emails.0" />
                              </Fragment>
                            );
                          }

                          return (
                            <Fragment key={index}>
                              <InputGroup className="input-group-merge mt-2">
                                <FormInput
                                  name={`billing_emails.${index}`}
                                  className="form-control-appended rounded-right"
                                  disabled={isSubmitting}
                                />
                                <InputGroupAddon addonType="append">
                                  <Button
                                    type="button"
                                    color="white"
                                    onClick={() => {
                                      setValues({
                                        ...values,
                                        billing_emails:
                                          values.billing_emails.filter(
                                            (_, i) => i !== index
                                          )
                                      });
                                    }}
                                  >
                                    x
                                  </Button>
                                </InputGroupAddon>
                              </InputGroup>
                              <FormFeedback
                                detached
                                name={`billing_emails.${index}`}
                              />
                            </Fragment>
                          );
                        })}
                      </FormGroup>
                      <Row>
                        <Col xs="9">
                          <FormGroup>
                            <Label>Billing Address*</Label>
                            <FormInput
                              name="address.address_1"
                              disabled={isSubmitting}
                            />
                            <FormFeedback name="address.address_1" />
                          </FormGroup>
                        </Col>
                        <Col xs="3">
                          <FormGroup>
                            <Label>Suite</Label>
                            <FormInput
                              name="address.address_2"
                              disabled={isSubmitting}
                            />
                            <FormFeedback name="address.address_2" />
                          </FormGroup>
                        </Col>
                      </Row>
                      <FormGroup>
                        <Label>City*</Label>
                        <FormInput
                          name="address.city"
                          disabled={isSubmitting}
                        />
                        <FormFeedback name="address.city" />
                      </FormGroup>
                      <FormGroup>
                        <Label>State*</Label>
                        <FormInput
                          name="address.state"
                          disabled={isSubmitting}
                          type="select"
                          options={STATE_OPTIONS}
                        />
                        <FormFeedback name="address.state" />
                      </FormGroup>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label>Zip*</Label>
                            <FormInput
                              name="address.postal_code"
                              disabled={isSubmitting}
                            />
                            <FormFeedback name="address.postal_code" />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>Country*</Label>
                            <FormInput
                              name="address.country"
                              disabled={isSubmitting}
                              type="select"
                              options={COUNTRIES}
                            />
                            <FormFeedback name="address.country" />
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="d-flex justify-content-end">
                        <FormSubmit className="mr-3">Submit</FormSubmit>
                      </div>
                    </Form>
                  );
                }}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
